export default "__VITE_ASSET__BVn8EvHC__"